<template>
  <el-dialog
    :visible.sync="currentlyVisible"
    :before-close="handleClose"
    title="Export current selection"
    width="30%"
  >
    <div class="action-text">
      <div v-if="filterBy === 'survey'">
        Exporting all respondents to
        <strong>CSV</strong> for survey
        <strong>{{ surveyName }}</strong>.
        <span v-if="questionTitle !== ''">
          For the question:
          <em class="question-title">{{ questionTitle }}</em>
        </span>
      </div>
      <div v-if="filterBy === 'period'">
        Exporting respondents to
        <strong>CSV</strong> for the period
        <strong>{{ periodType }}.</strong>
        <span v-if="periodType !== 'lifetime'">
          Starting from
          <strong>{{ datetime | moment('Do MMM YYYY') }}.</strong>
        </span>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="default" @click="handleClose">Cancel</el-button>
      <el-button type="primary" @click="exportRespondents">Export</el-button>
    </span>
  </el-dialog>
</template>

<script>
import moment from 'moment';
import gql from 'graphql-tag';

export default {
  name: 'SurveyExportFormDialog',
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    filterBy: {
      type: String,
    },
    surveyId: {
      type: Number,
    },
    surveyName: {
      type: String,
    },
    questionId: {
      type: Number,
      default: 0,
    },
    questionTitle: {
      type: String,
    },
    periodType: {
      type: String,
    },
    datetime: {
      type: Date,
    },
  },
  data: () => ({
    moment,
  }),
  computed: {
    period() {
      return this.periodType.toUpperCase();
    },
    filterVariables() {
      const keyMap = {
        survey: ['surveyId', 'questionId'],
        period: ['period', 'datetime'],
      };
      return keyMap[this.filterBy].reduce((acc, k) => {
        const value = this[k];
        return value ? { [k]: value, ...acc } : acc;
      }, {});
    },
    currentlyVisible: {
      get() {
        return this.isVisible;
      },
      set(newValue) {
        this.$emit('onVisibilityChange', newValue);
      },
    },
  },
  methods: {
    exportRespondents() {
      this.$apollo
        .mutate({
          client: 'apiv2',
          mutation: gql`
            mutation($filter: SurveyRespondentFilter!) {
              exportSurveyCsvRespondents(filter: $filter)
            }
          `,
          variables: {
            filter: this.filterVariables,
          },
        })
        .then(() => {
          this.handleClose();
        });
    },
    handleClose() {
      this.$emit('onVisibilityChange', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.action-text {
  font-size: 1.2em;
  color: #555;
}

.question-title {
  display: inline-block;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// SurveyExportFormDialog.vue?49bceaec